<template>
  <div id="authModal" class="modal fade auth-modal" tabindex="-1" aria-labelledby="authModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <img src="@/assets/images/logo.svg" alt="Info Global Logo" />
          <button ref="closeButton" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <component :is="currentView" @switchView="switchView" @close="closeModal" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, defineComponent, onMounted } from 'vue';
  import AuthView from '../AuthView.vue';
  import ForgotPasswordView from '../ForgotPasswordView.vue';
  import RegisterView from '../RegisterView.vue';
  import { Modal } from 'bootstrap';

  export default defineComponent({
    name: 'AuthModal',
    components: {
      AuthView,
      ForgotPasswordView,
      RegisterView,
    },
    setup() {
      const currentView = ref('AuthView');
      const closeButton = ref(null);
      let modalInstance = null;

      const switchView = (view) => {
        currentView.value = view;
      };
      const closeModal = () => {
        currentView.value = 'AuthView';
        closeButton.value.click();
      };
      const openModal = () => {
        if (modalInstance) {
          modalInstance.show();
        }
      };

      onMounted(() => {
        const modalElement = document.getElementById('authModal');
        if (modalElement) {
          modalInstance = new Modal(modalElement);
          modalElement.addEventListener('hide.bs.modal', () => {
            currentView.value = 'AuthView';
          });
        } else {
          console.error('Модальное окно не найдено');
        }
      });
      return {
        currentView,
        closeButton,
        switchView,
        closeModal,
        openModal,
      };
    },
  });
</script>

<style lang="scss">
  @import '@/assets/styles/auth';
</style>
